import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import MobileBlockPage from "@pages/mobile-block";

import { useAuth } from "@auth";
import { SignUpRouter } from "@pages/sign-up/router";
import { SignInRouter } from "@pages/sign-in/router";
import { DashboardRouter } from "@pages/dashboard/router";
import { Spinner } from "@atoms";
import { Toaster } from "@shadcn";
import { signalStartupComplete } from "@utils/preloader";

const isMobileDevice = (): boolean => {
  if (typeof navigator === "undefined") {
    return false;
  }
  const userAgent = navigator.userAgent || navigator.vendor || "";
  const isTouchMac =
    /Macintosh/.test(userAgent) &&
    typeof navigator.maxTouchPoints === "number" &&
    navigator.maxTouchPoints > 1;

  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent,
    ) || isTouchMac
  );
};

const Router = (): JSX.Element => {
  const { partner, isLoadingStartUpPartnerData } = useAuth();
  const isMobile = isMobileDevice();

  useEffect(() => {
    if (!isLoadingStartUpPartnerData) {
      signalStartupComplete();
    }
  }, [isLoadingStartUpPartnerData]);

  if (isMobile) {
    return <MobileBlockPage />;
  }

  if (isLoadingStartUpPartnerData) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={partner ? <DashboardRouter /> : <SignInRouter />}
        />
        <Route
          path="dashboard/*"
          element={partner ? <DashboardRouter /> : <SignInRouter />}
        />
        <Route
          path="signin/*"
          element={partner ? <DashboardRouter /> : <SignInRouter />}
        />
        <Route
          path="signup/*"
          element={partner ? <DashboardRouter /> : <SignUpRouter />}
        />
      </Routes>
      <Toaster />
    </>
  );
};

export default Router;
